export const defaultDashboardState = {};

export default {
	...defaultDashboardState
};
